<template>
  <div>
    <el-dialog :title="dialogInfo.title[dialogInfo.type]"
               v-dialogDrag
               :fullscreen="fullscreen"
               :visible.sync="dialogInfo.visible"
               :width="dialogInfo.width"
               :top="dialogTop"
               :custom-class="dialogCustomClass"
               :append-to-body="appendToBody"
               :modal-append-to-body="appendToBody"
               :close-on-click-modal="allowMaskClose"
               :close-on-press-escape="allowEscClose"
               :lock-scroll="false"
               ref="fullscreen"
               :before-close="handleClose"
               @opened="handleClick('opened')"
               @close="handleClick('close')">
      <div slot="title"
           style="padding:5px 0 5px">
        {{dialogInfo.title[dialogInfo.type]}}
        <div v-if="rightTopBtList.length"
             class="right-top-bt-wrap">
          <el-button v-for="item of rightTopBtList"
                     :key="item.event || item.label"
                     :loading="item.loading"
                     :type="item.type || ''"
                     :icon="item.icon"
                     size="mini"
                     @click.stop="handleClick(item.event)">{{item.label}}</el-button>
        </div>
        <el-button v-if="dialogInfo.fullscreen"
                   @click="bigscreen()"
                   class="button">
          <i v-show="!fullscreen"
             class="iconfont iconchuangkoufangda"></i>
          <i v-show="fullscreen"
             class="iconfont iconchuangkou"></i>
        </el-button>
        <el-button v-if="dialogInfo.switch"
                   @click="handleClick('switch')"
                   class="button">
          <i v-show="dialogInfo.formType==='one'"
             class="iconfont iconliebiao"
             style="font-size:14px"></i>
          <i v-show="dialogInfo.formType==='two'"
             class="el-icon-menu"></i>
        </el-button>
        <button v-if="allowManualClose"
                class="boyo-dialog-close"
                type="button"
                aria-label="关闭"
                @click.stop="requestClose">✕</button>
      </div>
      <slot></slot>
      <span v-if="dialogInfo.btList"
            slot="footer"
            class="dialog-footer">
        <el-button v-for="item of dialogInfo.btList"
                   :loading="item.loading"
                   :key="item.label"
                   :type="item.type"
                   :icon="item.icon"
                   v-show="item.show == undefined?true:item.show"
                   :style="item.style"
                   @click="handleClick(item.event)"
                   size="small">{{item.label}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BoyoDialog',
  props: {
    dialogInfo: Object
  },
  data () {
    return {
      fullscreen: false
    }
  },
  computed: {
    isRightDialog () {
      const info = this.dialogInfo || {}
      if (info.position === 'right') return true
      if (info.position === 'center') return false
      const type = String(info.type || '').toLowerCase()
      return ['add', 'update', 'edit', 'qx'].includes(type)
    },
    appendToBody () {
      const info = this.dialogInfo || {}
      if (info.appendToBody === true) return true
      if (info.appendToBody === false) return false
      return this.isRightDialog
    },
    dialogTop () {
      if (this.isRightDialog) return '0'
      const info = this.dialogInfo || {}
      if (info.top !== undefined && info.top !== null && info.top !== '') return String(info.top)
      if (info.center === true) return '0'
      return '15vh'
    },
    dialogCustomClass () {
      const info = this.dialogInfo || {}
      const parts = []
      if (this.isRightDialog) {
        parts.push(info.fitContentHeight ? 'boyo-dialog-right boyo-dialog-right-fit' : 'boyo-dialog-right')
      } else if (info.center === true) {
        parts.push('boyo-dialog-center')
      }
      if (info.customClass) parts.push(info.customClass)
      return parts.join(' ')
    },
    rightTopBtList () {
      const list = this.dialogInfo && this.dialogInfo.rightTopBtList
      return Array.isArray(list) ? list : []
    },
    allowManualClose () {
      return !(this.dialogInfo && this.dialogInfo.lockClose === true)
    },
    allowMaskClose () {
      if (this.dialogInfo && this.dialogInfo.lockClose === true) return false
      return true
    },
    allowEscClose () {
      if (this.dialogInfo && this.dialogInfo.lockClose === true) return false
      return true
    }
  },
  methods: {
    handleClose (done) {
      if (!this.allowManualClose) return
      if (this.dialogInfo.type === 'title' || this.dialogInfo.type === 'qx') {
        done()
      } else {
        this.$confirm('本次填写的内容将被清空且不会保存。确定要关闭吗？', '提示', {
          type: 'warning'
        }).then(() => {
          done()
        })
      }
    },
    requestClose () {
      if (!this.allowManualClose) return
      this.handleClose(() => {
        this.dialogInfo.visible = false
      })
    },
    handleClick (event) {
      this.$emit('dialogEvent', event)
    },
    bigscreen () {
      this.fullscreen = !this.fullscreen
      this.$refs.fullscreen.style.top = 0
      this.$refs.fullscreen.style.left = 0
    }
  }
}
</script>
<style lang="stylus" scoped>
.button
  position absolute
  top 10px
  right 44px
  padding 0
  // background 0 0
  border none
  outline 0
  cursor pointer
  font-size 16px

.right-top-bt-wrap
  position absolute
  top 4px
  right 44px
  display flex
  align-items center
  gap 8px

.boyo-dialog-close
  position absolute
  top 9px
  right 10px
  width 26px
  height 26px
  display inline-flex
  align-items center
  justify-content center
  border-radius 8px
  border 1px solid rgba(0,0,0,0.06)
  background rgba(0,0,0,0.02)
  color rgba(0,0,0,0.55)
  cursor pointer
  line-height 1
  font-size 15px
  transition background-color .18s ease, color .18s ease, border-color .18s ease
  &:hover
    background rgba(0,0,0,0.06)
    border-color rgba(0,0,0,0.12)
    color rgba(0,0,0,0.8)
</style>

<style lang="stylus">
.boyo-dialog-right
  margin 0 0 0 auto !important
  margin-top 0 !important
  margin-bottom 0 !important
  position fixed
  right 0
  top 0
  bottom 0
  height 100vh !important
  max-height 100vh !important
  display flex
  flex-direction column
  overflow hidden
  border-radius 0

.boyo-dialog-right .el-dialog__body
  flex 1
  min-height 0
  height auto !important
  max-height none !important
  overflow-y auto !important
  overflow-x hidden !important

.boyo-dialog-right .el-dialog__body::before,
.boyo-dialog-right .el-dialog__body::after
  content ''
  display table

.boyo-dialog-right .el-dialog__body::after
  clear both

.boyo-dialog-right .el-dialog__body .el-form::before,
.boyo-dialog-right .el-dialog__body .el-form::after
  content ''
  display table

.boyo-dialog-right .el-dialog__body .el-form::after
  clear both

.boyo-dialog-right .el-dialog__footer
  margin-top auto
  padding 8px 16px 4px
  border-top 1px solid #ebeef5
  background #fff
  flex-shrink 0

.dialog-fade-enter-active .boyo-dialog-right
  animation boyo-dialog-slide-in .18s ease-out !important

.dialog-fade-leave-active .boyo-dialog-right
  animation boyo-dialog-slide-out .14s ease-in !important

@keyframes boyo-dialog-slide-in
  0%
    transform translate3d(100%, 0, 0)
    opacity .9
  100%
    transform translate3d(0, 0, 0)
    opacity 1

@keyframes boyo-dialog-slide-out
  0%
    transform translate3d(0, 0, 0)
    opacity 1
  100%
    transform translate3d(100%, 0, 0)
    opacity .9

/* 居中弹窗：挂到 body，避免在侧栏编辑弹窗内定位偏移 */
.boyo-dialog-center.el-dialog
  margin-top 0 !important
  margin-bottom 0 !important
  position absolute
  top 50%
  left 50%
  transform translate(-50%, -50%)
  max-height calc(100vh - 80px)
  display flex
  flex-direction column

.boyo-dialog-center .el-dialog__body
  flex 1
  min-height 0
  overflow-y auto
</style>



// WEBPACK FOOTER //
// src/components/BoyoDialog/index.vue